var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultSimcard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:sim-card-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66699 12.6667H6.00033V11.3333H4.66699V12.6667ZM4.66699 10H6.00033V7.33334H4.66699V10ZM7.33366 12.6667H8.66699V10H7.33366V12.6667ZM7.33366 8.66668H8.66699V7.33334H7.33366V8.66668ZM10.0003 12.6667H11.3337V11.3333H10.0003V12.6667ZM10.0003 10H11.3337V7.33334H10.0003V10ZM4.00033 14.6667C3.63366 14.6667 3.31988 14.5362 3.05899 14.2753C2.7981 14.0145 2.66744 13.7005 2.66699 13.3333V5.33334L6.66699 1.33334H12.0003C12.367 1.33334 12.681 1.46401 12.9423 1.72534C13.2037 1.98668 13.3341 2.30045 13.3337 2.66668V13.3333C13.3337 13.7 13.2032 14.014 12.9423 14.2753C12.6814 14.5367 12.3674 14.6671 12.0003 14.6667H4.00033ZM4.00033 13.3333H12.0003V2.66668H7.23366L4.00033 5.90001V13.3333Z",
    fill: "#292D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultSimcard);
export default __webpack_public_path__ + "static/media/result_simcard.f12e9782b44354d20db7727fb343a824.svg";
export { ForwardRef as ReactComponent };